// Pasek postępu z łapką na górze ekranu i okrągły przycisk „do góry”.
import {gsap, ScrollTrigger, PAW_SVG, ARROW_SVG} from "./shared";

export function initProgress() {
    const bar = document.createElement("div");
    bar.className = "cc-progress";
    bar.setAttribute("aria-hidden", "true");
    bar.innerHTML = `<span class="cc-progress__bar"></span><span class="cc-progress__paw">${PAW_SVG}</span>`;
    document.body.appendChild(bar);
    gsap.fromTo(bar, {"--p": 0}, {"--p": 1, ease: "none", scrollTrigger: {start: 0, end: "max", scrub: 0.4}});
}

export function initBackToTop(lenis) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cc-totop";
    btn.setAttribute("aria-label", "Wróć na górę strony");
    btn.innerHTML = ARROW_SVG;
    document.body.appendChild(btn);
    gsap.set(btn, {autoAlpha: 0, scale: 0.4, rotation: -90});

    let shown = false;
    ScrollTrigger.create({
        start: 900,
        end: "max",
        onToggle: (self) => {
            if (self.isActive === shown) {
                return;
            }
            shown = self.isActive;
            gsap.to(btn, shown
                ? {autoAlpha: 1, scale: 1, rotation: 0, duration: 0.7, ease: "back.out(2.2)", overwrite: "auto"}
                : {autoAlpha: 0, scale: 0.4, rotation: -90, duration: 0.3, ease: "power2.in", overwrite: "auto"});
        }
    });

    btn.addEventListener("click", () => {
        if (lenis) {
            lenis.scrollTo(0, {duration: 1.4});
        } else {
            window.scrollTo({top: 0, behavior: "smooth"});
        }
        document.querySelector(".cc-header__logo")?.focus({preventScroll: true});
    });
}
